import { useEffect, useState } from 'react';
import { Loader2, Sparkles } from 'lucide-react';
import { toast } from 'sonner';
import { studioApi } from '@/lib/studioApi';
import { useStudioImage } from '@/hooks/useStudioImage';
import { placeAsset } from './ObjectPanels';

const SOURCE = { upload: 'Eigenes Bild', stock: 'Bibliothek', ai: 'KI-Bild' };

const RecentTile = ({ item, index, onPick, disabled }) => {
  const { url } = useStudioImage(item.id);
  return <button type="button" className="recent-tile" onClick={() => onPick(item)} disabled={disabled} aria-label={`${SOURCE[item.source]} verwenden: ${item.name}`} data-testid={`recent-item-${index}`}>
    {url ? <img src={url} alt="" /> : <Loader2 size={16} className="spin" />}
    <span className="recent-source">{item.source === 'ai' && <Sparkles size={10} />}{SOURCE[item.source]}</span>
  </button>;
};

// Pictures this guest already used (uploads, library, AI) – one tap reuses them without uploading again.
export const RecentPanel = ({ editor, setPanel, processing }) => {
  const [items, setItems] = useState(null);
  useEffect(() => { let alive = true; studioApi('/uploads/recent').then(d => alive && setItems(d.items)).catch(e => { if (alive) { setItems([]); toast.error(e.message); } }); return () => { alive = false; }; }, []);
  const pick = item => {
    const target = placeAsset(editor, item, item.name, processing, item.source === 'ai' ? { aiGenerated: true } : {});
    setPanel(target ? 'object' : 'crop');
  };
  if (items === null) return <p className="small-note" data-testid="recent-loading"><Loader2 size={14} className="spin" /> Deine Bilder werden geladen …</p>;
  if (!items.length) return <p className="small-note" data-testid="recent-empty">Noch keine Bilder verwendet. Lade ein Bild hoch, wähle eins aus der Foto-Bibliothek oder erstelle eins mit KI.</p>;
  return <div data-testid="recent-panel"><div className="recent-grid" data-testid="recent-grid">{items.map((item, i) => <RecentTile key={item.id} item={item} index={i} onPick={pick} disabled={editor.objects.length >= 12 && !editor.swap} />)}</div>
    <p className="small-note" data-testid="recent-note">Nur auf diesem Gerät sichtbar · privat gespeichert.</p></div>;
};
